module.exports = __webpack_public_path__ + "img/webapp-button.56271354.svg";